export default __webpack_public_path__ + "static/icon-airplane-802aafd9e7410f1701f350d002583932.svg";